import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import {
  Product,
  UiLandingProductCardBioderma
} from '@/fo/ui/landing/product-card/bioderma';
import { addLandingProductToCart } from '@/fo/util/landing-prices';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './GammaProducts.styles';

export interface GammaProductsProps {
  products: Product[];
}

export function GammaProducts({ products }: GammaProductsProps) {
  const slots = styles();

  return (
    <div
      className={slots.base()}
      id="all-sebium-products"
    >
      <h3 className={slots.title()}>
        Попробуйте другие средства гаммы{' '}
        <span className="text-[#00C389]">SÉBIUM</span>
      </h3>
      <UiKitCarouselBase
        className={slots.products()}
        arrowPrevClass={slots.arrowPrev()}
        arrowNextClass={slots.arrowNext()}
        alwaysShowArrows
        loop={false}
      >
        {products.map((product, index) => (
          <UiLandingProductCardBioderma
            className={slots.productCard()}
            classNameImageWrapper={slots.imageWrapper()}
            key={product.sku}
            product={product}
            positionIndex={index}
            onAddToCart={() => addLandingProductToCart(product)}
            listItemVariant="dot"
            classNameList="gap-1 md:min-h-[128px]"
          />
        ))}
      </UiKitCarouselBase>

      <UiKitButtonBase
        className={slots.allProductsButton()}
        href="/catalog/bioderma/gammy/sebium/"
        as="link"
        target="_blank"
        onClick={() => {
          reachMetrikaGoal('perehod_v_kategoriu_kataloga');
        }}
      >
        Все средства гаммы
      </UiKitButtonBase>
    </div>
  );
}
